'use client';
import { useIsDesktop } from '@/_hooks/useBreakpoint';

import React, { Dispatch } from 'react';
import Desktop from './responsive/desktop';
import Mobile from './responsive/mobile';

const EditUserData = ({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: Dispatch<boolean>;
}) => {
  const isDesktop = useIsDesktop();
  return isDesktop ? (
    <Desktop isOpen={isOpen} setIsOpen={setIsOpen} />
  ) : (
    <Mobile isOpen={isOpen} setIsOpen={setIsOpen} />
  );
};

export default EditUserData;
